import styled from 'styled-components';
import markerMask from '../../assets/images/marker-mask.png';

export const MapContainer = styled.div`
  .search-local {
    min-width: 240px;
    margin: 12px 0 24px 0;
  }

  .search-loading {
    display: flex;
    align-items: center;

    p {
      margin-left: 5px;
      margin-right: 10px;
      font-style: italic;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.text_gray};
    }
  }

  .infoBox {
    width: 76px !important;
    & > img {
      display: none;
    }
  }

  .google-map {
    border-radius: 1rem;
    box-shadow: 2px 4px 6px rgb(0 0 0 / 20%);
  }

  #custom-marker {
    background: transparent;
    border: none;
    outline: none;
    width: 76px;

    div {
      -webkit-mask-image: url(${markerMask});
      mask-image: url(${markerMask});
      -webkit-mask-size: 100%;
      mask-size: 100%;
      -webkit-mask-position: center center;
      mask-position: center center;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
`;
